export const UPLOAD_IMAGE_CROP_SHAPE = {
  CIRCLE: 'circle',
  RECTANGLE: 'rectangle',
  SQUARE: 'square',
}

// `data-corner` on the stage handles maps a pointer-down to the dragged corner.
export const UPLOAD_IMAGE_CROP_CORNER = {
  NE: 'ne',
  NW: 'nw',
  SE: 'se',
  SW: 'sw',
}

export const UPLOAD_IMAGE_CROP_CORNERS = [
  UPLOAD_IMAGE_CROP_CORNER.NW,
  UPLOAD_IMAGE_CROP_CORNER.NE,
  UPLOAD_IMAGE_CROP_CORNER.SE,
  UPLOAD_IMAGE_CROP_CORNER.SW,
]

export const UPLOAD_IMAGE_MIN_CROP_SIZE = 48

export const UPLOAD_IMAGE_ROTATION_STEP = 90

export const UPLOAD_IMAGE_DEFAULT_RECTANGLE_ASPECT = 2.5

export const UPLOAD_IMAGE_OUTPUT_TYPE = 'image/png'
